import styled from 'styled-components';
import Login, { LoginWrap, GoogleLogin } from '../Login/Login.stc';

export const SignUpWrap = styled(LoginWrap)``;
export const GoogleSignUp = styled(GoogleLogin)`
    margin-top: -15px;
    margin-bottom: 30px;

    > div {
        margin: 0 auto;
    }
`;

const SignUp = styled(Login)``;

export default SignUp;
